export const GET_AUDIOS = 'GET_AUDIOS'
export const SET_AUDIOS = 'SET_AUDIOS'
export const UPDATE_VOLUME = 'UPDATE_VOLUME'
export const PLAY_AUDIO = 'PLAY_AUDIO'
export const PAUSE_AUDIO = 'PAUSE_AUDIO'
export const STOP_AUDIO = 'STOP_AUDIO'
export const CHANGE_PANNER = 'CHANGE_PANNER'
export const AUDIO_CHANGE = 'AUDIO_CHANGE'
export const DURATION_CHANGE = 'DURATION_CHANGE'
export const PROGRESSBAR_CHANGE = 'PROGRESSBAR_CHANGE'
export const PROGRESSBAR_INCREMENT = 'PROGRESSBAR_INCREMENT';
export const UPDATE_DISTORTION = 'UPDATE_DISTORTION';
export const UPDATE_FREQUENCY = 'UPDATE_FREQUENCY';
export const UPDATE_DELAY_MIX = 'UPDATE_DELAY_MIX';
export const SET_SOUND_EFFECTS = 'SET_SOUND_EFFECTS';
export const PLAY_SOUND_EFFECT = 'PLAY_SOUND_EFFECT';
export const STOP_SOUND_EFFECT = 'STOP_SOUND_EFFECT';

export const LOADING_START = 'LOADING_START';
export const LOADING_DONE = 'LOADING_DONE';